export const DATA_ITEM = 'DATA_ITEM';
export const SHOP_ITEM = 'SHOP_ITEM';
export const SHOP_ITEM_CATEGORY = 'SHOP_ITEM_CATEGORY';
export const DEFAULT_PAGE = 1;
export const DEFAULT_PER_PAGE = 20;
// Used for shop/data items
export const DEFAULT_ITEM_PER_PAGE = 5;
export const DEFAULT_PAGE_SIZE_OPTIONS = ['5', '10', '20'];
export const ANTD_PAGINATION = {
  current: 1,
  pageSize: 20,
  total: 0,
};



// WEBPACK FOOTER //
// ./app/constants/PAGINATION.ts